export default __webpack_public_path__ + "static/media/refreshIcon.67825669.svg";